import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import Vue from 'vue';
var axios_intsace_get_unclaims = get_axios_instance(api_variables.SERVICE_FBP_UN_CLAIM)
const state={
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
}
 const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record
    }
}
const mutations ={
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setRecord: (state, payload) => {
        state.record = payload.record;
    }
}
const actions={
    async fetchAll({ commit }, payload) {
        try {
            console.log("i am called")
            commit("setFetching", true);
            console.log(payload)
            let res = await axios_intsace_get_unclaims.get(``, {
                params:
                {
                    le_id: payload.le_id,
                    financial_year: payload.financial_year,
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setRecord", [res.data.payload, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
}
export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}